<template>
  <hr :color="color" />
</template>

<script>
export default {
  name: 'SimpleHr',
  props: {
    color: {
      type: String,
      default: 'black'
    }
  }
}
</script>
